import { Badge, type BadgeVariant } from '@/components/ui/Badge';

interface RequestLoggerTagProps {
  method?: string;
  status?: number;
  app?: string;
  tag?: string;
  onClick?: () => void;
  selected?: boolean;
}

const getMethodVariant = (method: string): BadgeVariant => {
  const variantMap = {
    GET: 'default',
    POST: 'success',
    PUT: 'warning',
    DELETE: 'destructive',
    PATCH: 'warning',
  };

  return (variantMap[method as keyof typeof variantMap] ||
    'secondary') as BadgeVariant;
};

const getStatusVariant = (status: number): BadgeVariant => {
  if (status < 200) return 'destructive';
  if (status < 300) return 'success';
  if (status < 400) return 'default';
  if (status < 500) return 'warning';
  return 'destructive';
};

const getTagVariant = (tag: string): BadgeVariant => {
  const variantMap = {
    success: 'success',
    error: 'destructive',
    'client-error': 'destructive',
    'server-error': 'destructive',
  };

  const variant = variantMap[tag as keyof typeof variantMap];

  if (!variant) return 'secondary';

  return variant as BadgeVariant;
};

export function RequestLoggerTag({
  method,
  status,
  app,
  tag,
  onClick,
  selected = false,
}: RequestLoggerTagProps) {
  let variant: BadgeVariant = 'secondary';

  if (method) {
    variant = getMethodVariant(method);
  } else if (status) {
    variant = getStatusVariant(status);
  } else if (tag) {
    variant = getTagVariant(tag);
  }

  return (
    <Badge variant={variant} onClick={onClick} data-selected={selected}>
      {method || status || app || tag}
    </Badge>
  );
}
